import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { OfferCardTransactionTypePrice } from './OfferCardTransactionTypePrice';
export function OfferCardFooterDesktop() {
    return (_jsx(Box, { testId: "offer-card-footer-desktop", padding: "spacing.16", display: "flex", flexDirection: "column", gap: "spacing.16", flex: 0, children: _jsx(OfferCardTransactionTypePrice, {}) }));
}
